<template>
  <section class="w-full h-full px-4 py-4 box-border overflow-hidden" v-loading="loading">
    <div class="w-full h-full bg-white overflow-auto">
      <share-coord-manage :question-id="questionId" :all-refresh.sync="allRefresh" ref="scManage" v-if="showManage" />
      <div class="w-full h-full flex flex-col items-center" v-else>
        <div class="w-full h-full">
          <div class="text-center text-theme-black-850 font-medium text-20 leading-22 mt-16">{{'问卷' | replaceText($route.query.scene,['Vote','Appointment'].includes($route.query.scene)? 1 : 0)}}协作</div>
          <p class="mb-4 font-normal text-theme-black-650 text-center leading-22 mt-4 mb-4 text-medium">
            按需分配协作用户权限，数据更安全
          </p>
          <el-button type="primary" @click="showCoordShare = true" class="m-auto block">添加协作用户</el-button>
          <div class="mt-8 text-center" style="height: 56%;">
            <img src="@/assets/img/wj/share1.png" v-if="personal" class="w-auto h-full" />
            <img src="@/assets/img/wj/share2.png" v-else class="w-auto h-full" />
          </div>
        </div>
      </div>
    </div>
    <share-coord-dialog :visible.sync="showCoordShare" :question-id="questionId" />
  </section>
</template>

<script>
import GlobalConfig from '@/global/config'
import { getWJCoordUserList, getWJCoordLinkList } from '@/api/wenjuan/wjquestion'
import ShareCoordManage from '@/views/home/project/components/ShareCoordManage'
import ShareCoordDialog from '@/views/home/project/components/ShareCoordDialog'
import { isPersonal } from '@/assets/js/config/env'

export default {
  name: 'ShareCollaboration',
  components: {
    ShareCoordManage,
    ShareCoordDialog
  },
  data() {
    return {
      questionId: GlobalConfig.getSurveyId(),
      allRefresh: false,
      loading: false,
      showManage: false,
      showCoordShare: false,
      personal: true
    }
  },
  watch: {
    showCoordShare(bool) {
      if (!bool) {
        this.refreshCoordHandler()
      }
    }
  },
  mounted() {
    this.getManageStatus()
    this.$surveyBus.$on('refreshCoord', this.refreshCoordHandler)
    this.personal = this.isPersonal()
  },
  beforeDestroy() {
    this.$surveyBus.$off('refreshCoord', this.refreshCoordHandler)
  },
  methods: {
    refreshCoordHandler() {
      this.getManageStatus()
    },
    getManageStatus() {
      const params = {
        size: 1,
        current: 1,
        wjId: this.questionId
      }
      const pmList = [getWJCoordUserList(params), getWJCoordLinkList(params)]
      this.loading = true
      Promise.all(pmList)
        .then(([userRes, linkRes]) => {
          const { code: uCode, msg: uMsg, data: uData } = userRes.data || {}
          const { code: lCode, msg: lMsg, data: lData } = linkRes.data || {}
          if (uCode === 0 && lCode === 0) {
            const uList = uData?.records || []
            const lList = lData?.records || []
            this.showManage = uList.length > 0 || lList.length > 0
            if (this.showManage) {
              this.allRefresh = true
            }
            this.$nextTick(() => {
              if (this.$refs.scManage) {
                if (uList.length > 0) {
                  this.$refs.scManage.setActiveTab('user')
                } else if (lList.length > 0) {
                  this.$refs.scManage.setActiveTab('link')
                }
              }
            })
          } else {
            this.$message.error(uMsg ?? lMsg ?? '获取用户状态失败')
          }
        })
        .catch(() => {
          this.$message.error('获取用户状态失败')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
